import { Injectable } from '@angular/core';
import { BeneficiaryListFactoryService } from '../factory/beneficiary-list-store-factory';
import {
  Meta,
  BeneficiaryListFilter,
} from 'projects/merchant-portal/src/app/models/disbursement/beneficiary-list/beneficiary-list.interface';
import { BehaviorSubject, Observable, Subject, map, switchMap, share, tap } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { BeneficiaryListApiFatoryService } from '../factory/beneficiary-list-api-fatory.service';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaryListService extends BeneficiaryListFactoryService {
  private _isLoading$ = new BehaviorSubject(false);
  private loadTrigger$ = new Subject<Partial<BeneficiaryListFilter>>();
  private lastRequestKey = '';
  private lastRequestTime = 0;

  override currentBeneficiaryListFilter$: Observable<Partial<BeneficiaryListFilter>> =
    this.activeRouter.queryParams.pipe(
      map(value => ({
        beneficiaryAccountName: value['beneficiaryAccountName'],
        beneficiaryAccountNo: value['beneficiaryAccountNo'],
        startCreatedAt: value['startCreatedAt'],
        endCreatedAt: value['endCreatedAt'],
        page: value['page'],
      }))
    );

  private currentBeneficiaryListResponse$ = this.loadTrigger$.pipe(
    tap(() => this._isLoading$.next(true)),
    switchMap(value => this.beneficiaryListApiFatoryService.getBeneficiaryList(value)),
    tap(() => this._isLoading$.next(false)),
    share()
  );

  override currentBeneficiaryList$ = this.currentBeneficiaryListResponse$.pipe(
    map(value => value.data)
  );

  override currentBeneficiaryListPagination$: Observable<Meta> =
    this.currentBeneficiaryListResponse$.pipe(map(value => value.meta));

  override requestBeneficiaryList(param: Partial<BeneficiaryListFilter>): void {
    const key = JSON.stringify(param);
    const now = Date.now();
    if (key === this.lastRequestKey && now - this.lastRequestTime < 1000) return;
    this.lastRequestKey = key;
    this.lastRequestTime = now;
    this.loadTrigger$.next(param);
  }

  constructor(
    private beneficiaryListApiFatoryService: BeneficiaryListApiFatoryService,
    private activeRouter: ActivatedRoute,
    private router: Router
  ) {
    super();
  }
}
